import Failure from "../../../core/Failure";
import { message } from "antd";
import { Authentication } from "@leedpulse-monorepo/classes";

async function refreshActiveAdmin(serviceUrl: string, env: string, auth: Authentication | null): Promise<void> {
  const token = auth?.token;
  if (!token) {
    message.error("Vous devez être connecté pour rafraîchir la configuration.");
    return;
  }

  const response = await fetch(`${serviceUrl}/api/v1/admin/runtime-config/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ env }),
  });

  if (!response.ok) {
    message.error("Impossible de rafraîchir la configuration du service.");
    throw new RefreshActiveAdminFailure(`HTTP ${response.status}`);
  }

  message.success("Configuration rafraîchie avec succès.");
}

export class RefreshActiveAdminFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default refreshActiveAdmin;
